function ResourceMeedyVO(id, medicalPost, name, defaultAppointmentLength, address, phone, mobilePhone, fax, email, www, color, organizationalUnit, resortCodeV, resortCodeVII, placeOfSupplyOfServicesCode) {

    this.id = id;
    this.medicalPost = medicalPost;
    this.name = name;
    this.defaultAppointmentLength = defaultAppointmentLength;
    this.address = address;
    this.phone = phone;
    this.mobilePhone = mobilePhone;
    this.fax = fax;
    this.email = email;
    this.www = www;
    this.color = color;
    this.organizationalUnit = organizationalUnit;
    this.resortCodeV = resortCodeV;
    this.resortCodeVII = resortCodeVII;
    this.placeOfSupplyOfServicesCode = placeOfSupplyOfServicesCode;

    var _typeContext = {
        medicalPost : MedicalPostMeedyVO,
        address : AddressMeedyVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
